(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('tsf-announcement')) {
    customElements.define('tsf-announcement', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.pauseButton = this.querySelector('[data-marquee-control]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.pauseButton.addEventListener('click', () => {
          this.toggleAttribute('data-paused');
          this.syncControl();
        }, options);
        this.motion.addEventListener('change', () => {
          this.fillGroups();
          this.syncControl();
        }, options);
        window.addEventListener('pageshow', () => this.expireMessages(), options);
        window.addEventListener('resize', () => this.fillGroups(), options);
        document.addEventListener('visibilitychange', () => {
          this.toggleAttribute('data-page-hidden', document.hidden);
          this.expireMessages();
        }, options);
        this.setAttribute('data-initialized', '');
        this.expireMessages();
        this.syncControl();
      }
      fillGroups() {
        const viewport = this.querySelector('.announcement__viewport');
        const track = this.querySelector('[data-marquee-track]');
        if (!viewport || !track) return;
        if (getComputedStyle(track).display !== 'flex') {
          window.cancelAnimationFrame(this.fillFrame);
          this.fillFrame = window.requestAnimationFrame(() => this.fillGroups());
          return;
        }
        window.cancelAnimationFrame(this.fillFrame);
        this.querySelectorAll('[data-marquee-copy]').forEach(message => message.remove());
        if (this.motion.matches) return;
        this.querySelectorAll('[data-marquee-group]').forEach(group => {
          const originals = Array.from(group.querySelectorAll('.announcement__message:not([data-marquee-copy])'));
          if (!originals.length) return;
          let cycles = 0;
          while (group.scrollWidth < viewport.clientWidth * 1.25 && cycles < 12) {
            originals.forEach(message => {
              const copy = message.cloneNode(true);
              copy.setAttribute('data-marquee-copy', '');
              copy.setAttribute('aria-hidden', 'true');
              copy.inert = true;
              group.append(copy);
            });
            cycles += 1;
          }
        });
      }
      expireMessages() {
        window.clearTimeout(this.expiryTimer);
        const now = Date.now();
        this.querySelectorAll('.announcement__message[data-expires-at]').forEach(message => {
          const expiry = Date.parse(message.dataset.expiresAt);
          if (Number.isFinite(expiry) && expiry <= now) message.remove();
        });
        const primary = Array.from(this.querySelectorAll('[data-marquee-group]:not([data-marquee-clone]) .announcement__message'));
        this.hidden = primary.length === 0;
        if (!this.hidden) this.fillGroups();
        const future = primary
          .map(message => Date.parse(message.dataset.expiresAt))
          .filter(expiry => Number.isFinite(expiry) && expiry > now);
        if (future.length) {
          this.expiryTimer = window.setTimeout(
            () => this.expireMessages(),
            Math.min(Math.min(...future) - now, 2147483647)
          );
        }
      }
      syncControl() {
        const paused = this.hasAttribute('data-paused');
        this.pauseButton.hidden = this.motion.matches;
        this.pauseButton.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.pauseButton.querySelector('[data-marquee-icon]').textContent = paused ? '▶' : 'Ⅱ';
      }
      disconnectedCallback() {
        window.clearTimeout(this.expiryTimer);
        window.cancelAnimationFrame(this.fillFrame);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!document.documentElement.dataset.tsfCartBound) {
    document.documentElement.dataset.tsfCartBound = 'true';
    const updateCart = async (section) => {
      if (section.dataset.updatingCart === 'true') return;
      const form = section.querySelector('[data-cart-form]');
      const inputs = Array.from(form.querySelectorAll('[data-cart-quantity]'));
      if (!inputs.every(input => input.value.trim() !== '' && input.checkValidity())) { form.reportValidity(); return; }
      const updates = inputs.map(input => Number(input.value));
      const activeIndex = inputs.indexOf(document.activeElement);
      const status = section.querySelector('[data-cart-status]');
      const controls = Array.from(form.querySelectorAll('input, button:not([name="checkout"])'));
      const disabledBefore = controls.map(control => control.disabled);
      section.dataset.updatingCart = 'true';
      form.setAttribute('aria-busy', 'true');
      if (status) status.textContent = section.dataset.updating || 'Updating your cart…';
      controls.forEach(control => { control.disabled = true; });
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates, sections: [section.dataset.sectionId], sections_url: window.location.pathname })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || section.dataset.error || 'Your cart could not be updated.');
        const html = cart.sections?.[section.dataset.sectionId];
        const next = html ? new DOMParser().parseFromString(html, 'text/html').getElementById(section.id) : null;
        if (!next) { window.location.reload(); return; }
        document.querySelectorAll('.site-header__cart-count').forEach(badge => {
          if (cart.item_count === 0) badge.remove();
          else if (Number.isInteger(cart.item_count)) {
            badge.textContent = String(cart.item_count);
            badge.setAttribute('aria-label', String(cart.item_count));
          }
        });
        const checkoutRequested = section.dataset.checkoutAfterUpdate === 'true';
        section.replaceWith(next);
        if (checkoutRequested) {
          const checkoutForm = next.querySelector('[data-cart-form]');
          const checkoutButton = checkoutForm?.querySelector('[name="checkout"]');
          if (checkoutForm && checkoutButton) checkoutForm.requestSubmit(checkoutButton);
        } else if (activeIndex >= 0) {
          const nextInputs = next.querySelectorAll('[data-cart-quantity]');
          nextInputs[Math.min(activeIndex, nextInputs.length - 1)]?.focus({ preventScroll: true });
        }
      } catch (error) {
        inputs.forEach(input => { input.value = input.dataset.originalQuantity; });
        if (status) status.textContent = error.message || section.dataset.error;
      } finally {
        delete section.dataset.updatingCart;
        delete section.dataset.checkoutAfterUpdate;
        form.removeAttribute('aria-busy');
        controls.forEach((control, index) => { control.disabled = disabledBefore[index]; });
      }
    };
    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-cart-quantity]')) return;
      const section = event.target.closest('[data-cart-section]');
      if (section) updateCart(section);
    });
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-cart-remove]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const section = link.closest('[data-cart-section]');
      if (!section) return;
      event.preventDefault();
      if (section.dataset.updatingCart === 'true') return;
      const input = section.querySelectorAll('[data-cart-quantity]')[Number(link.dataset.line) - 1];
      if (!input) return;
      input.value = '0';
      updateCart(section);
    });
    document.addEventListener('submit', (event) => {
      if (!event.target.matches('[data-cart-form]')) return;
      const section = event.target.closest('[data-cart-section]');
      if (event.submitter?.name === 'checkout') {
        if (section.dataset.updatingCart === 'true') {
          event.preventDefault();
          section.dataset.checkoutAfterUpdate = 'true';
        }
        return;
      }
      event.preventDefault();
      updateCart(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function buildPredictiveSearchUrl(endpoint, term) {
    const params = new URLSearchParams({
      q: term,
      'resources[type]': 'query,product,collection,page,article',
      'resources[limit]': '10',
      'resources[options][unavailable_products]': 'last',
      section_id: 'predictive-search',
    });
    return `${endpoint}?${params.toString()}`;
  }

  function nextOptionIndex(current, count, direction) {
    if (count === 0) return -1;
    return (current + direction + count) % count;
  }

  class SquishyPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-predictive-search-input]');
      this.results = this.querySelector('[data-predictive-search-results]');
      this.status = this.querySelector('[data-predictive-search-status]');
      this.disclosure = this.closest('[data-search-disclosure]');
      this.closeButton = this.querySelector('[data-search-close]');
      this.activeIndex = -1;
      this.abortController = null;
      this.timer = null;

      this.input.addEventListener('input', () => this.queueSearch());
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      this.disclosure.addEventListener('toggle', () => {
        if (this.disclosure.open) {
          this.input.focus();
        } else {
          this.clearResults();
        }
      });
      this.closeButton.addEventListener('click', () => this.close());
    }

    queueSearch() {
      clearTimeout(this.timer);
      if (this.abortController) this.abortController.abort();
      const term = this.input.value.trim();
      if (term.length < 2) {
        this.clearResults();
        return;
      }
      this.timer = setTimeout(() => this.getResults(term), 180);
    }

    async getResults(term) {
      this.abortController = new AbortController();
      this.status.textContent = this.dataset.loadingText;

      try {
        const response = await fetch(buildPredictiveSearchUrl(this.dataset.endpoint, term), {
          signal: this.abortController.signal,
        });
        if (!response.ok) throw new Error(`Predictive search returned ${response.status}`);

        const text = await response.text();
        const documentFragment = new DOMParser().parseFromString(text, 'text/html');
        const section = documentFragment.querySelector('#shopify-section-predictive-search');
        if (!section) throw new Error('Predictive search section was not returned');

        this.results.innerHTML = section.innerHTML;
        this.activeIndex = -1;
        const root = this.results.querySelector('[data-predictive-search-root]');
        const count = Number(root?.dataset.resultCount || 0);
        this.input.setAttribute('aria-expanded', 'true');
        this.status.textContent = count > 0
          ? this.dataset.resultsText.replace('[count]', String(count))
          : this.dataset.emptyText;
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.clearResults();
        this.status.textContent = this.dataset.errorText;
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      const options = Array.from(this.results.querySelectorAll('[role="option"]'));
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (options.length === 0) return;
        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        this.activeIndex = nextOptionIndex(this.activeIndex, options.length, direction);
        this.selectOption(options);
      } else if (event.key === 'Enter' && this.activeIndex >= 0) {
        const link = options[this.activeIndex]?.querySelector('a');
        if (link) {
          event.preventDefault();
          link.click();
        }
      }
    }

    selectOption(options) {
      options.forEach((option, index) => {
        const selected = index === this.activeIndex;
        option.setAttribute('aria-selected', String(selected));
        option.classList.toggle('is-active', selected);
      });
      const active = options[this.activeIndex];
      if (active?.id) this.input.setAttribute('aria-activedescendant', active.id);
      active?.scrollIntoView({ block: 'nearest' });
    }

    clearResults() {
      this.results.innerHTML = '';
      this.activeIndex = -1;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }

    close() {
      this.disclosure.open = false;
      this.clearResults();
      this.disclosure.querySelector('summary')?.focus();
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', SquishyPredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.querySelectorAll('[data-registration-form]').forEach((form) => {
    const interest = form.querySelector('[data-registration-interest]');
    const tags = form.querySelector('[data-registration-tags]');
    interest.addEventListener('change', () => {
      tags.value = interest.value;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    if (!select) return;
    const price = section.querySelector('[data-current-price]');
    const compare = section.querySelector('[data-compare-price]');
    const availability = section.querySelector('[data-availability]');
    const button = section.querySelector('[data-add-to-cart]');
    const label = section.querySelector('[data-add-label]');
    const availableText = section.dataset.availableLabel;
    const unavailableText = section.dataset.unavailableLabel;
    const addText = section.dataset.addLabel;
    const soldOutText = section.dataset.soldOutLabel;
    const blockedText = section.dataset.blockedLabel;
    const canPurchase = section.dataset.canPurchase === 'true';

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      price.textContent = option.dataset.price;
      compare.textContent = option.dataset.comparePrice || '';
      compare.hidden = !option.dataset.comparePrice;
      availability.textContent = available ? availableText : unavailableText;
      button.disabled = !available || !canPurchase;
      if (!canPurchase) {
        label.textContent = blockedText;
      } else {
        label.textContent = available ? addText : soldOutText;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });

  document.querySelectorAll('[data-press-video]').forEach((container) => {
    const video = container.querySelector('video');
    if (!video) return;

    video.addEventListener(
      'play',
      () => {
        window.publishSquishyEvent?.('squishy:press_video_played', {
          product_id: container.dataset.productId,
          media_id: container.dataset.mediaId,
        });
      },
      { once: true },
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-pair-offer')) {
    customElements.define('home-pair-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        window.addEventListener('pageshow', () => this.syncVisibility(), options);
        document.addEventListener('visibilitychange', () => this.syncVisibility(), options);
        this.syncVisibility();
      }
      syncVisibility() {
        window.clearTimeout(this.offerTimer);
        const now = Date.now();
        const startsAt = Date.parse(this.dataset.startsAt);
        const endsAt = Date.parse(this.dataset.endsAt);
        this.hidden = (Number.isFinite(startsAt) && now < startsAt) || (Number.isFinite(endsAt) && now >= endsAt);
        const nextBoundary = [startsAt, endsAt].filter(boundary => Number.isFinite(boundary) && boundary > now);
        if (nextBoundary.length) {
          this.offerTimer = window.setTimeout(
            () => this.syncVisibility(),
            Math.min(Math.min(...nextBoundary) - now, 2147483647)
          );
        }
      }
      disconnectedCallback() {
        window.clearTimeout(this.offerTimer);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["segmented-newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.newsletter__form').forEach((form) => {
    const tags = form.querySelector('[data-preference-tags]');
    form.addEventListener('change', (event) => {
      if (event.target.name === 'contact[interest]') {
        tags.value = `newsletter,${event.target.value}`;
        window.publishSquishyEvent?.('squishy:newsletter_segment_selected', {
          interest: event.target.value,
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
